<template>
  <div v-if="channelEnabled && enabled">
    <div class="sc--whatsapp-button">
      <img
        src="https://www.svgrepo.com/show/81119/whatsapp.svg"
        @click="openWhatsappWeb()"
        @mouseenter="changePopUpState(true)"
        @mouseleave="changePopUpState(false)"
      >
    </div>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="showPopUp"
        class="sc--whatsapp-pop-up sc-clean"
      >
        <div class="sc--whatsapp-pop-up-title">
          {{ configuration.title || 'Canal de atención WhatsApp' }}
        </div>
        <div class="sc--whatsapp-pop-up-body">
          {{ configuration.description || 'Puedes comunicarte a través de nuestro número' }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ProtocolWhatsappButton from '../../protocolWhatsAppButton'
export default {
  name: 'WhatsAppButton',
  data: () => {
    return {
      enabled: false,
      channelEnabled: false,
      configuration: {},
      number: '',
      showPopUp: false
    }
  },
  created () {
    this.protocol = new ProtocolWhatsappButton(this, window.GB_SETUP)
    this.protocol.onStart()
  },
  methods: {
    openWhatsappWeb () {
      let url = `https://wa.me/${this.number}`
      if (this.configuration.userText) url += `?text=${this.configuration.userText}`
      window.open(url, '_blank')
    },
    changePopUpState (state) {
      this.showPopUp = state
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap');

.sc--whatsapp-button {
  position: fixed;
  bottom: 25px;
  right: 25px;
}

.sc--whatsapp-button img {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  cursor: pointer;
}

.sc--whatsapp-button img:hover {
  box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
}

.sc--whatsapp-pop-up {
  position: fixed;
  bottom: 105px;
  right: 25px;
  max-width: 150px;
  border-radius: 25px;
  background-color: white;
  box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
  font-family: 'Roboto', sans-serif;
}

.sc--whatsapp-pop-up::after {
  content: "";
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid white;
  position: fixed;
  right: 55px;
}

.sc--whatsapp-pop-up-title {
  width: 100%;
  border-radius: 24px 24px 0 0;
  box-sizing: border-box;
  padding: 12px;
  background-color: black;
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.sc--whatsapp-pop-up-body {
  padding: 12px;
  color: rgb(65, 65, 65);
  font-size: 12px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5 ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media ( max-width: 450px ) {
  .sc--whatsapp-pop-up {
    display: none;
  }
}
</style>
